import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_CSAT_RESPONSE_RATE, SUPERSET_CSAT_RESPONSE_RATE_ERROR, SUPERSET_CSAT_RESPONSE_RATE_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetCsatResponseRate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_CSAT_RESPONSE_RATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_CSAT_RESPONSE_RATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_CSAT_RESPONSE_RATE_ERROR, payload: error });
  }
}

export function* watchSupersetCsatResponseRate() {
  yield takeEvery(SUPERSET_CSAT_RESPONSE_RATE, supersetCsatResponseRate);
}

function* supersetCsatResponseRateSaga() {
  yield all([fork(watchSupersetCsatResponseRate)]);
}

export default supersetCsatResponseRateSaga;
